export const content = `BetterHelp accepts the following forms of payment:

- Credit cards
- Health Savings Accounts (HSA) via card
- Flexible Spending Accounts (FSA) via card
- Insurance, if your plan is in network with BetterHelp

If you’re paying with insurance, you may still owe a copay, coinsurance, or deductible. [See which insurance plans we accept](/support/articles/accept-my-insurance).
`;
